
import { sha256 } from 'js-sha256';

var self = {
  generate: function (data) {
    let plaingString = "";
    const soretedData = self.sortObjetAlphabetically(data);
    for (const key in soretedData) {
      if (key !== "secureHash")
        plaingString += data[key]
    }
    return sha256(process.env.REACT_APP_API_SECRATE_KEY + plaingString);
  },
  sortObjetAlphabetically: function (data) {
    const sorted = Object.keys(data)
      .sort()
      .reduce((accumulator, key) => {
        accumulator[key] = data[key];

        return accumulator;
      }, {});
    return sorted;
  }
};






export default self;